/**
 * Based on https://www.joshwcomeau.com/snippets/react-hooks/use-prefers-reduced-motion/
 *
 * Deviation from the original: the initial state is the SAME on the server and
 * on the client's first render. The original returns `true` on the server and
 * the real media-query result on the client, which is fine when the value only
 * drives effects — but several components here branch on it *in render*. Under
 * hydration that is a structural mismatch, and React resolves it by reusing the
 * wrong DOM nodes (it silently mangled the nav). The real preference is read on
 * mount instead, one tick later.
 *
 * Consumers must therefore list `prefersReducedMotion` in their effect deps, or
 * their effect will run once against the placeholder value and never again.
 */

import { useState, useEffect } from 'react';

const QUERY = '(prefers-reduced-motion: no-preference)';

function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(true);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);

    setPrefersReducedMotion(!mediaQueryList.matches);

    const listener = event => {
      setPrefersReducedMotion(!event.matches);
    };

    mediaQueryList.addListener(listener);
    return () => {
      mediaQueryList.removeListener(listener);
    };
  }, []);

  return prefersReducedMotion;
}

export default usePrefersReducedMotion;
